import React from 'react';
import { Card } from '../components';

const ViewCard = ({ cardData }) => {
    return <Card cardData={cardData} />;
};

export default ViewCard;
